import React, { useState } from "react";
import DashboardLayout from "../../components/DashboardLayout/DashboardLayout";
import "./Settings.css";

const Settings = () => {
  const [settings, setSettings] = useState({
    notifications: {
      emailNotifications: true,
      appointmentReminders: true,
      blogUpdates: false,
      promotions: false,
    },
    privacy: {
      publicProfile: false,
      shareHealthData: false,
      allowResearch: true,
    },
    security: {
      twoFactor: false,
      loginAlerts: true,
      deviceManagement: true,
    },
  });

  const handleToggle = (category, setting) => {
    setSettings((prev) => ({
      ...prev,
      [category]: {
        ...prev[category],
        [setting]: !prev[category][setting],
      },
    }));
  };

  return (
    <DashboardLayout>
      <div className="settings-page">
        <div className="settings-header">
          <h2>Settings</h2>
          <p>Manage your account preferences and settings</p>
        </div>

        {/* Notification Settings */}
        <div className="settings-section">
          <div className="section-header">
            <h3>🔔 Notifications</h3>
            <p>Control how and when you receive notifications</p>
          </div>
          <div className="settings-list">
            <div className="setting-item">
              <div className="setting-info">
                <h4>Email Notifications</h4>
                <p>Receive important updates via email</p>
              </div>
              <label className="toggle-switch">
                <input
                  type="checkbox"
                  checked={settings.notifications.emailNotifications}
                  onChange={() =>
                    handleToggle("notifications", "emailNotifications")
                  }
                />
                <span className="slider"></span>
              </label>
            </div>

            <div className="setting-item">
              <div className="setting-info">
                <h4>Appointment Reminders</h4>
                <p>Get reminders for upcoming appointments</p>
              </div>
              <label className="toggle-switch">
                <input
                  type="checkbox"
                  checked={settings.notifications.appointmentReminders}
                  onChange={() =>
                    handleToggle("notifications", "appointmentReminders")
                  }
                />
                <span className="slider"></span>
              </label>
            </div>

            <div className="setting-item">
              <div className="setting-info">
                <h4>Blog Updates</h4>
                <p>Notify me about new blog posts</p>
              </div>
              <label className="toggle-switch">
                <input
                  type="checkbox"
                  checked={settings.notifications.blogUpdates}
                  onChange={() => handleToggle("notifications", "blogUpdates")}
                />
                <span className="slider"></span>
              </label>
            </div>

            <div className="setting-item">
              <div className="setting-info">
                <h4>Promotions & Offers</h4>
                <p>Receive promotional offers and discounts</p>
              </div>
              <label className="toggle-switch">
                <input
                  type="checkbox"
                  checked={settings.notifications.promotions}
                  onChange={() => handleToggle("notifications", "promotions")}
                />
                <span className="slider"></span>
              </label>
            </div>
          </div>
        </div>

        {/* Privacy Settings */}
        <div className="settings-section">
          <div className="section-header">
            <h3>🔒 Privacy</h3>
            <p>Control your privacy and data sharing</p>
          </div>
          <div className="settings-list">
            <div className="setting-item">
              <div className="setting-info">
                <h4>Public Profile</h4>
                <p>Let others find and view your profile</p>
              </div>
              <label className="toggle-switch">
                <input
                  type="checkbox"
                  checked={settings.privacy.publicProfile}
                  onChange={() => handleToggle("privacy", "publicProfile")}
                />
                <span className="slider"></span>
              </label>
            </div>

            <div className="setting-item">
              <div className="setting-info">
                <h4>Share Health Data</h4>
                <p>Allow sharing of health information with healthcare providers</p>
              </div>
              <label className="toggle-switch">
                <input
                  type="checkbox"
                  checked={settings.privacy.shareHealthData}
                  onChange={() => handleToggle("privacy", "shareHealthData")}
                />
                <span className="slider"></span>
              </label>
            </div>

            <div className="setting-item">
              <div className="setting-info">
                <h4>Allow Research</h4>
                <p>Allow your anonymized data to be used in medical research</p>
              </div>
              <label className="toggle-switch">
                <input
                  type="checkbox"
                  checked={settings.privacy.allowResearch}
                  onChange={() => handleToggle("privacy", "allowResearch")}
                />
                <span className="slider"></span>
              </label>
            </div>
          </div>
        </div>

        {/* Security Settings */}
        <div className="settings-section">
          <div className="section-header">
            <h3>🛡️ Security</h3>
            <p>Enhance your account security</p>
          </div>
          <div className="settings-list">
            <div className="setting-item">
              <div className="setting-info">
                <h4>Two-Factor Authentication</h4>
                <p>Add an extra layer of security to your account</p>
              </div>
              <label className="toggle-switch">
                <input
                  type="checkbox"
                  checked={settings.security.twoFactor}
                  onChange={() => handleToggle("security", "twoFactor")}
                />
                <span className="slider"></span>
              </label>
            </div>

            <div className="setting-item">
              <div className="setting-info">
                <h4>Login Alerts</h4>
                <p>Get notified of new login attempts</p>
              </div>
              <label className="toggle-switch">
                <input
                  type="checkbox"
                  checked={settings.security.loginAlerts}
                  onChange={() => handleToggle("security", "loginAlerts")}
                />
                <span className="slider"></span>
              </label>
            </div>

            <div className="setting-item">
              <div className="setting-info">
                <h4>Device Management</h4>
                <p>Manage and review connected devices</p>
              </div>
              <label className="toggle-switch">
                <input
                  type="checkbox"
                  checked={settings.security.deviceManagement}
                  onChange={() => handleToggle("security", "deviceManagement")}
                />
                <span className="slider"></span>
              </label>
            </div>
          </div>
        </div>

        {/* Danger Zone */}
        <div className="settings-section danger-zone">
          <div className="section-header">
            <h3>⚠️ Danger Zone</h3>
            <p>Irreversible actions</p>
          </div>
          <div className="danger-actions">
            <button className="danger-btn">Change Password</button>
            <button className="danger-btn delete-btn">Delete Account</button>
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default Settings;
